module.exports = __webpack_public_path__ + "img/26ne.e84da2ab.svg";